// src/pages/MeetingInfo.js
import React, { useState } from "react";

const MeetingInfo = () => {
  const [meetings, setMeetings] = useState([
    {
      id: 1,
      date: "2025-11-10",
      time: "11:00",
      venue: "ग्रामपंचायत भवन",
      agenda: "पाणी पुरवठा आणि रस्ते दुरुस्ती",
      notes: "सभाप्रतिनिधी उपस्थित राहावे",
    },
    {
      id: 2,
      date: "2025-12-05",
      time: "10:30",
      venue: "कार्यालय सभा कक्ष",
      agenda: "अर्थसंकल्प मंजुरी",
      notes: "वकील आणि लेखापाल सहयोगी",
    },
  ]);

  const [form, setForm] = useState({ date: "", time: "", venue: "", agenda: "", notes: "" });
  const [editingId, setEditingId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [search, setSearch] = useState("");

  const resetForm = () => setForm({ date: "", time: "", venue: "", agenda: "", notes: "" });

  const handleAdd = () => {
    if (!form.date || !form.time || !form.venue) {
      alert("कृपया तारीख, वेळ, आणि स्थळ भरा.");
      return;
    }
    const newMeeting = { id: Date.now(), ...form };
    setMeetings([newMeeting, ...meetings]);
    resetForm();
    setShowForm(false);
  };

  const handleEdit = (m) => {
    setEditingId(m.id);
    setForm({ date: m.date, time: m.time, venue: m.venue, agenda: m.agenda, notes: m.notes });
    setShowForm(true);
  };

  const handleUpdate = () => {
    setMeetings(meetings.map((m) => (m.id === editingId ? { ...m, ...form } : m)));
    setEditingId(null);
    resetForm();
    setShowForm(false);
  };

  const handleDelete = (id) => {
    if (!window.confirm("तुम्ही खात्रीने हा सभा रेकॉर्ड डिलीट करू इच्छिता?")) return;
    setMeetings(meetings.filter((m) => m.id !== id));
  };

  const filtered = meetings.filter((m) => {
    const q = search.toLowerCase();
    if (!q) return true;
    return (
      m.date.includes(q) ||
      m.time.includes(q) ||
      m.venue.toLowerCase().includes(q) ||
      m.agenda.toLowerCase().includes(q) ||
      (m.notes || "").toLowerCase().includes(q)
    );
  });

  return (
    <div style={styles.container}>
      {/* ===== Header ===== */}
      <div style={styles.header}>
        <h2 style={styles.title}>सभेची माहिती</h2>
        <div style={styles.actions}>
          <input
            type="text"
            placeholder="शोधा (तारीख/स्थळ/अजेंडा)"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={styles.searchInput}
          />
          <button
            onClick={() => {
              resetForm();
              setEditingId(null);
              setShowForm((s) => !s);
            }}
            style={showForm ? styles.cancelButton : styles.addButton}
          >
            {showForm ? "फॉर्म बंद करा" : "नवीन सभा जोडा"}
          </button>
        </div>
      </div>

      {/* ===== Add/Edit Form ===== */}
      {showForm && (
        <div style={styles.formCard}>
          <div style={styles.formGrid}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>तारीख</label>
              <input
                type="date"
                value={form.date}
                onChange={(e) => setForm({ ...form, date: e.target.value })}
                style={styles.input}
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>वेळ</label>
              <input
                type="time"
                value={form.time}
                onChange={(e) => setForm({ ...form, time: e.target.value })}
                style={styles.input}
              />
            </div>

            <div style={styles.inputGroupFull}>
              <label style={styles.label}>स्थळ / Venue</label>
              <input
                value={form.venue}
                onChange={(e) => setForm({ ...form, venue: e.target.value })}
                style={styles.input}
                placeholder="उदा. ग्रामपंचायत भवन"
              />
            </div>

            <div style={styles.inputGroupFull}>
              <label style={styles.label}>अजेंडा</label>
              <input
                value={form.agenda}
                onChange={(e) => setForm({ ...form, agenda: e.target.value })}
                style={styles.input}
                placeholder="उदा. पाणी पुरवठा, रस्ते"
              />
            </div>

            <div style={styles.inputGroupFull}>
              <label style={styles.label}>नोंद (Notes)</label>
              <textarea
                value={form.notes}
                onChange={(e) => setForm({ ...form, notes: e.target.value })}
                style={styles.textarea}
                rows={3}
                placeholder="उदा. सभाप्रतिनिधी उपस्थित राहावे"
              />
            </div>
          </div>

          <div style={styles.formActions}>
            {editingId ? (
              <>
                <button onClick={handleUpdate} style={styles.updateButton}>अद्यतनित करा</button>
                <button onClick={() => { resetForm(); setEditingId(null); setShowForm(false); }} style={styles.cancelButton}>
                  रद्द करा
                </button>
              </>
            ) : (
              <>
                <button onClick={handleAdd} style={styles.addButton}>सभा जोडा</button>
                <button onClick={() => { resetForm(); setShowForm(false); }} style={styles.cancelButton}>
                  रद्द करा
                </button>
              </>
            )}
          </div>
        </div>
      )}

      {/* ===== Meetings Table ===== */}
      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead style={styles.thead}>
            <tr>
              <th style={styles.th}>तारीख</th>
              <th style={styles.th}>वेळ</th>
              <th style={styles.th}>स्थळ</th>
              <th style={styles.th}>अजेंडा</th>
              <th style={styles.th}>नोंद</th>
              <th style={styles.th}>कृती</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan="6" style={styles.noData}>
                  कोणतीही सभा उपलब्ध नाही.
                </td>
              </tr>
            ) : (
              filtered.map((m) => (
                <tr key={m.id} style={styles.tr}>
                  <td style={styles.td}>{m.date}</td>
                  <td style={styles.td}>{m.time}</td>
                  <td style={styles.td}>{m.venue}</td>
                  <td style={styles.td}>{m.agenda}</td>
                  <td style={styles.td}>{m.notes}</td>
                  <td style={styles.td}>
                    <div style={styles.actionButtons}>
                      <button onClick={() => handleEdit(m)} style={styles.editButton}>सुधारणा</button>
                      <button onClick={() => handleDelete(m.id)} style={styles.deleteButton}>डिलीट</button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ===== Footer Tip ===== */}
      
    </div>
  );
};

// ====== Internal CSS (Jordar Design) ======
const styles = {
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    maxWidth: "1000px",
    margin: "20px auto",
    padding: "20px",
    background: "#f5f9ff",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
    border: "1px solid #d0e4ff",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "25px",
    paddingBottom: "15px",
    borderBottom: "3px solid #1e88e5",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1565c0",
    margin: 0,
  },
  actions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  searchInput: {
    padding: "10px 14px",
    fontSize: "15px",
    border: "2px solid #90caf9",
    borderRadius: "8px",
    width: "260px",
    outline: "none",
    transition: "border 0.3s",
  },
  addButton: {
    background: "#1976d2",
    color: "white",
    padding: "10px 18px",
    border: "none",
    borderRadius: "8px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "all 0.3s",
    boxShadow: "0 3px 6px rgba(25,118,210,0.3)",
  },
  cancelButton: {
    background: "#e0e0e0",
    color: "#333",
    padding: "10px 18px",
    border: "none",
    borderRadius: "8px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "all 0.3s",
  },

  // Form Card
  formCard: {
    background: "white",
    padding: "25px",
    borderRadius: "14px",
    marginBottom: "25px",
    boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
    border: "1px solid #bbdefb",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "18px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
  },
  inputGroupFull: {
    gridColumn: "1 / -1",
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#1565c0",
    marginBottom: "6px",
  },
  input: {
    padding: "10px 12px",
    fontSize: "15px",
    border: "2px solid #90caf9",
    borderRadius: "8px",
    outline: "none",
    transition: "border 0.3s",
  },
  textarea: {
    padding: "10px 12px",
    fontSize: "15px",
    border: "2px solid #90caf9",
    borderRadius: "8px",
    outline: "none",
    resize: "vertical",
    minHeight: "80px",
  },
  formActions: {
    marginTop: "20px",
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
  },
  updateButton: {
    background: "#43a047",
    color: "white",
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0 3px 6px rgba(67,160,71,0.3)",
  },

  // Table
  tableContainer: {
    background: "white",
    borderRadius: "14px",
    overflow: "hidden",
    boxShadow: "0 6px 15px rgba(0,0,0,0.08)",
    border: "1px solid #bbdefb",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  thead: {
    background: "linear-gradient(135deg, #1976d2, #1565c0)",
    color: "white",
  },
  th: {
    padding: "14px 10px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "15px",
  },
  tr: {
    borderBottom: "1px solid #e0e0e0",
    transition: "background 0.2s",
  },
  td: {
    padding: "12px 10px",
    textAlign: "center",
    fontSize: "14.5px",
    color: "#333",
  },
  noData: {
    padding: "30px",
    color: "#999",
    fontStyle: "italic",
  },
  actionButtons: {
    display: "flex",
    gap: "8px",
    justifyContent: "center",
  },
  editButton: {
    background: "#ffb300",
    color: "white",
    padding: "6px 12px",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  deleteButton: {
    background: "#e53935",
    color: "white",
    padding: "6px 12px",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    cursor: "pointer",
    fontWeight: "bold",
  },

  // Tip
  tip: {
    marginTop: "20px",
    padding: "12px 16px",
    background: "#e8f5e9",
    borderRadius: "10px",
    fontSize: "14px",
    color: "#2e7d32",
    border: "1px dashed #81c784",
    textAlign: "center",
  },
};

// Hover Effects (via JS if needed, but inline styles are fine)
Object.assign(styles.addButton, {
  ":hover": { background: "#1565c0", transform: "translateY(-2px)" },
});
Object.assign(styles.editButton, {
  ":hover": { background: "#ff8f00" },
});
Object.assign(styles.deleteButton, {
  ":hover": { background: "#c62828" },
});

export default MeetingInfo;